// Polis, the Sonar tab: talk to the voters of a wave (11 October 2026).
export default {
  chargement: 'Reading the voters of the wave…',
  erreur: 'The voters of this wave could not be read.',
  reessayer: 'Try again',
  fermer: 'Close',
  chapeau: {
    titre: 'Talk to the voters of the {vague} wave',
    texte: 'Choose a group: those who voted in this wave answer you, each in their own voice, with their vote and their reasons.',
  },
  vague: {
    libelle: 'Wave',
    option: '{jour} · {libelle}',
    optionHeure: '{base} · {heure}',
  },
  vide: {
    titre: 'No completed wave yet',
    texte: 'You can meet the voters as soon as a wave has finished voting.',
    projection: 'Go to the projections',
  },
  sections: {
    listes: 'The voters of each list',
    candidats: 'The voters of each candidate',
    indecis: 'Those still hesitating',
    secteurs: 'The sectors of the electorate',
    segments: 'The main groups of the electorate',
    legendePart: 'their share of the electorate',
  },
  indecis: 'Undecided voters',
  titres: {
    vote: '{nom} voters',
    persona: '{nom} voters · {segment}',
  },
  phrase: {
    surtout: 'mostly ‘{segment}’ ({part})',
    age: 'median age {n}',
    femmes: '{n} women',
    votent: 'vote first for {premier}',
    puis: ', then {suivant}',
    entourage: 'around them, people vote first for {premier}',
    indecis: 'undecided',
    abstention: 'not voting',
  },
  interroger: 'Talk to them',
  reprendre: 'Resume the conversation',
  introuvable: 'This group does not have enough voters in this wave to answer you: choose another one.',
  aucunGroupe: 'No group in this wave has enough voters to answer.',
  conversations: {
    titre: 'Your conversations with the voters',
    legende: 'every wave of this election',
  },
  // The questions offered to get started, depending on the group.
  questions: {
    vote1: 'What made up your mind?',
    vote2: 'What could change your mind before the vote?',
    vote3: 'What do people around you say?',
    indecis1: 'Who are you hesitating between, and why?',
    indecis2: 'What would make up your mind?',
    indecis3: 'What is still holding you back?',
    groupe1: 'What matters most to you in this election?',
    groupe2: 'Who are you voting for, and why?',
    groupe3: 'What worries you at the moment?',
  },
}
